import type { ReactNode } from "react";

import { Button } from "./Button";
import { Dialog } from "./Dialog";

export interface ConfirmDialogProps {
  open: boolean;
  title: string;
  /** What is about to happen, stated plainly. Irreversible must say so. */
  description: string;
  confirmLabel: string;
  cancelLabel?: string;
  destructive?: boolean;
  busy?: boolean;
  onConfirm: () => void;
  onClose: () => void;
  children?: ReactNode;
}

/** A yes/no dialog on top of the shell's `Dialog`, so the trap and focus rules are shared. */
export function ConfirmDialog({
  open,
  title,
  description,
  confirmLabel,
  cancelLabel = "Cancel",
  destructive = false,
  busy = false,
  onConfirm,
  onClose,
  children,
}: ConfirmDialogProps): ReactNode {
  return (
    <Dialog open={open} onClose={onClose} title={title} width="sm">
      <p className="text-sm text-muted">{description}</p>
      {children}
      <div className="mt-5 flex justify-end gap-2">
        <Button variant="ghost" onClick={onClose}>
          {cancelLabel}
        </Button>
        <Button
          variant={destructive ? "danger" : "primary"}
          disabled={busy}
          onClick={onConfirm}
          autoFocus
        >
          {busy ? "Working…" : confirmLabel}
        </Button>
      </div>
    </Dialog>
  );
}
